import { useState, useEffect } from 'react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { AlertTriangle } from 'lucide-react'
import { sessionManager } from '@/utils/sessionManager'

const SessionWarning = () => {
  const [showWarning, setShowWarning] = useState(false)
  const [timeRemaining, setTimeRemaining] = useState(0)

  useEffect(() => {
    // Listen for session warnings
    sessionManager.onWarning(() => {
      setShowWarning(true)
      setTimeRemaining(5 * 60) // 5 minutes in seconds
    })

    // Countdown timer
    const interval = setInterval(() => {
      setTimeRemaining(prev => {
        if (prev <= 0) {
          setShowWarning(false)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const handleExtendSession = () => {
    sessionManager.extendSession()
    setShowWarning(false)
    setTimeRemaining(0)
  }

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins}:${secs.toString().padStart(2, '0')}`
  }

  if (!showWarning) return null

  return (
    <div className="fixed top-4 right-4 z-50 w-80">
      <Alert className="border-warning bg-warning/10">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle>Sitzung läuft bald ab</AlertTitle>
        <AlertDescription className="space-y-2">
          <p>
            Ihre Sitzung läuft in {formatTime(timeRemaining)} ab.
          </p>
          <Button 
            onClick={handleExtendSession}
            size="sm"
            className="w-full"
          >
            Sitzung verlängern
          </Button>
        </AlertDescription>
      </Alert>
    </div>
  )
}

export default SessionWarning